import { Button, Grid2, Typography } from "@mui/material";
import React, { useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const names = [
  { name: "Service", value: "SERVICE" },
  { name: "Civil", value: "CIVIL" },
  { name: "Supply", value: "SUPPLY" },
  { name: "Consultancy", value: "CONSULTANCY" },
  { name: "Framework Agreement", value: "FRAMEWORK" },
  { name: "Others", value: "OTHERS" },
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 1;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 150,
    },
  },
};

const VendorDetails = () => {
  const [categories, setCategories] = useState([]);
  const [details, setDetails] = useState();
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [errors, setErrors] = useState({})

  const handleChange = (e) => {
    const updatedValue =
      e.target.name === "pan" ? e.target.value.toUpperCase() : e.target.value;
    setDetails({ ...details, [e.target.name]: updatedValue });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = details || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

    if (isEmpty(data.name)) newErrors.name = "Name is required";
    if (isEmpty(data.firmName)) newErrors.firmName = "Firm Name is required";

    if (isEmpty(data.pan)) {
      newErrors.pan = "PAN is required";
    } else if (!panRegex.test(data.pan)) {
      newErrors.pan = "Invalid PAN format (e.g. ABCDE1234F)";
    }

    if (categories.length === 0) {
      newErrors.categories = "At least one category must be selected";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }

  const handleCategoryChange = (event) => {
    const {
      target: { value },
    } = event;
    setCategories(typeof value === "string" ? value.split(",") : value);
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/vendor/details`,
        {
          email: storedUser.username,
          name: details.name,
          firmName: details.firmName,
          pan: details.pan,
          categories: categories,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      navigate("/vendor/dashboard");
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="App">
      <div className="border-container">
        <Typography variant="h4" textAlign={"center"} mb={5}>
          Enter Your Details
        </Typography>
        <form>
          <Grid2 container columnSpacing={4}>
            <Grid2 size={{ xs: 12, sm: 6 }}>
              <label htmlFor="name">Your Name (Contact Person)</label>
              <input
              className={`${errors.name && "input-error"}`}
                type="text"
                name="name"
                id="name"
                onChange={handleChange}
              />
              {errors.name && <p className="error">{errors.name}</p> }
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }}>
              <label htmlFor="firmName">Your Firm Name</label>
              <input
              className={`${errors.firmName && "input-error"}`}
                type="text"
                name="firmName"
                id="firmName"
                onChange={handleChange}
              />
              {errors.firmName && <p className="error">{errors.firmName}</p>}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }}>
              <label htmlFor="pan">PAN (Proprietor/Firm)</label>
              <input 
              className={`${errors.pan && "input-error"}`}
              type="text" name="pan" id="pan" onChange={handleChange} />
              {errors.pan && <p className="error">{errors.pan}</p>}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }}>
              <label htmlFor="categories">
                Select Your Categories <br />
              </label>
              <Select
              className={`${errors.categories && "input-error"}`}
                labelId="categories"
                name="categories"
                id="categories"
                multiple
                value={categories}
                onChange={handleCategoryChange}
                renderValue={(selected) => selected.join(", ")}
                MenuProps={MenuProps}
                sx={{
                  width: "100%",
                  height: "35px",
                  marginTop: "10px",
                  border: "1px solid black",
                }}
              >
                {names.map((name) => (
                  <MenuItem
                    key={name.name}
                    value={name.value}
                    sx={{ height: "40px" }}
                  >
                    <Checkbox checked={categories.includes(name.value)} />
                    <ListItemText primary={name.name} />
                  </MenuItem>
                ))}
                {errors.categories && <p className="error">{errors.categories}</p>}
              </Select>
            </Grid2>
          </Grid2>
          <Button className="btn-contained" fullWidth onClick={handleSubmit}>
            Save
          </Button>
        </form>
      </div>
    </div>
  );
};

export default VendorDetails;
